import Vue from 'vue'
import Vuex from 'vuex'
import state from './store'
import mutations from './mutation'
import getters from './getters'

Vue.use(Vuex);
const store = new Vuex.Store({
	state,
	mutations,
	getters
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js